

export const insertBreakablePoints = (link) => {
    return link.replace(/([/?=&])/g, '$1\u200B');
  };
  
  
export const insertBreakablePointsInEmail = (email) => {
return email.replace(/([@.])/g, '$1\u200B');
};